import axios from "axios";
import toQueryString from "../common/utils/to-query-string";

const reorderWeek = (weeklyScheduleId, weekIndex) => {
  return axios.put(`api/v1/plan-managements/weeklySchedule/${weeklyScheduleId}/reorder`, { weekIndex });
};

const getPlanList = () => axios.get("api/v1/plans");

const getPlans = (query) => axios.get(toQueryString("api/v1/plan-managements?", query));

const createPlan = () => axios.post("api/v1/plan-managements");

const getPlanById = (id, query) => axios.get(toQueryString(`api/v1/plan-managements/${id}?`, query));

const updateWeeklySchedule = (planId, task) => {
  return axios.put(
    `api/v1/plan-managements/${planId}/upsertWeeklyScheduleActivity`,
    {
      ...task,
      dailyTaskId: task.DailyTask?.id ?? null,
      scenarioId: task.scenarioId,
    }
  );
};

const upsertDateSchedule = (planId, task) => {
  return axios.put(
    `api/v1/plan-managements/${planId}/upsertDateScheduleActivity`,
    {
      ...task,
      dailyTaskId: task.dailyTaskId ?? null,
    }
  );
};

const updatePlan = (id, field) =>
  axios.put(`api/v1/plan-managements/${id}`, field);

const updatePlanCohort = (planId, groupScheduleIds) =>
  axios.put(
    `api/v1/plan-managements/${planId}/update`,
    groupScheduleIds
  );

const updatePlanLogic = (planId, completionLogic) =>
  axios.put(
    `api/v1/plan-managements/${planId}/update`,
    completionLogic
  );

const deletePlan = (id) => axios.delete(`api/v1/plan-managements/${id}`);

const deletePlans = (ids) =>
  axios.delete("api/v1/plan-managements/bulk", {
    data: { ids },
  });

const deleteActivity = (planId, activityId) =>
  axios.delete(
    `api/v1/plan-managements/${planId}/deleteWeeklyScheduleActivity/${activityId}`
  );

const deleteTriggeredActivity = (planId, activityId) =>
  axios.delete(
    `api/v1/plan-managements/${planId}/deleteDateScheduleActivity/${activityId}`
  );

const activatePlan = (id) =>
  axios.put(
    `api/v1/plan-managements/${id}/activate`
  );

const discardPlan = (id) =>
  axios.put(
    `api/v1/plan-managements/${id}/discard`
  );

const duplicatePlan = (id) =>
  axios.post(`api/v1/plan-managements/${id}/duplicate`);

const addWeek = (id) =>
  axios.post(`api/v1/plan-managements/${id}/add-week`);

const duplicateWeek = (weeklyScheduleId) =>
  axios.post(`api/v1/plan-managements/weeklySchedule/${weeklyScheduleId}/duplicate-week`);

const deleteWeek = (weeklyScheduleId) =>
  axios.delete(`api/v1/plan-managements/weeklySchedule/${weeklyScheduleId}`);

const applyWeekDayPatch = (planId, patch) =>
  axios.post(`api/v1/plan-managements/${planId}/week-day-patch`, patch);

const updatePlanDefaultData = (planId, payload) =>
  axios.put(`api/v1/plan-managements/${planId}/default-data`, payload);

const ApiPlanManagement = {
  getPlanList,
  getPlans,
  getPlanById,
  createPlan,
  updateWeeklySchedule,
  updatePlan,
  deletePlan,
  deletePlans,
  deleteActivity,
  activatePlan,
  discardPlan,
  updatePlanCohort,
  duplicatePlan,
  addWeek,
  duplicateWeek,
  deleteWeek,
  reorderWeek,
  updatePlanLogic,
  upsertDateSchedule,
  deleteTriggeredActivity,
  applyWeekDayPatch,
  updatePlanDefaultData
};

export default ApiPlanManagement;
